import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { IChangeLog } from "app/models/core/lab/changeLog";
import { SharedService } from "app/services/core/shared.service";
import { LabService } from "app/services/lab/lab.service";


@Component({
  selector: 'app-change-log',
  templateUrl: './changeLog.component.html'
})

export class ChangeLogComponent implements OnInit {
  @Input() stateNumber: string = '';
  changes: IChangeLog[] = [];

  displayedColumns: string[] = ['type', 'oldValue', 'newValue',
    'dateChanged', 'changedBy'
  ];

  dataSource = new MatTableDataSource<IChangeLog>(this.changes);

  selectedLab = '';
  listFilter = '';

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(public labService: LabService,
    public sharedService: SharedService) { };

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
if (this.labService.lab != null) {
      this.getChangeLog();
    }
  }

  getChangeLog(): void {
    if (this.stateNumber != '') {
      this.labService.getChangeLog(this.stateNumber).subscribe(
        res => {
          this.changes = res;
          this.dataSource.data = this.changes;
        },
        error => console.log('error: ', error),
        () => {
        }
      );
    }
  }

  filterTable(evnt: Event) {
    this.listFilter = (evnt.target as HTMLInputElement).value;
    this.dataSource.filter = this.listFilter.trim().toLowerCase();
  }

  clearFilter() {
    this.listFilter = "";
    this.dataSource.filter = this.listFilter;
  }

  getPageSizeOptions(): number[] {
    if (this.dataSource.data.length > 20) {
      return [10, 20, this.dataSource.data.length];
    } else {
      return [10, 20];
    }
  }
}


